export const quotations = {
  alerts: {
    errorDuplicateEntryNumber: 'Vous avez déjà utilisé le numéro de devis « {{entryNumber}} ».',
    missingFcFiles_one: 'Le PDF de ce devis est introuvable.',
    missingFcFiles_other: 'Les PDF de ces devis sont introuvables.',
    successCreated: 'Votre devis a été créé.',
    successDeleted: 'Votre brouillon a été supprimé.',
    successUpdated: 'Votre devis a été modifié.',
  },
  breadcrumb: {
    create: 'Détails du devis',
    noTitle: 'Sans titre',
    overview: 'Devis',
  },
  clientAccept: {
    card: {
      button: 'Approuver le devis',
      description: {
        accept: 'Vous êtes d’accord avec le devis de {{user}} ? Approuvez-le via le bouton ci-dessous.',
        accepted: 'Le devis a été marqué comme approuvé.',
        declined: 'Le devis a été marqué comme refusé.',
        expired: 'Le devis a expiré et ne peut plus être approuvé.',
      },
      title: 'Devis de {{user}}',
    },
    preview: {
      assignment: {
        title: 'Mission',
      },
      client: 'Données du client',
      conditions: {
        description: 'Consultez les conditions générales de ce devis',
        title: 'Conditions générales',
      },
      createdBy: 'Ce devis a été établi et envoyé par',
      description: 'Description',
      expirationDate: 'Valable jusqu’au',
      freelancer: 'Exécutant de la mission',
      introduction: 'Introduction',
      specialConditions: 'Conditions particulières',
      title: 'Titre',
    },
  },
  createEdit: {
    assignment: {
      description: 'Décrivez brièvement en quoi consiste votre mission.',
      title: 'Mission',
    },
    attachments: {
      description: 'Ajoutez d’éventuels documents à ce devis.',
      error: {
        delete: 'Une erreur s’est produite lors de la suppression de la pièce jointe.',
      },
      title: 'E-mail et pièces jointes',
    },
    basicInfo: {
      description: 'Toutes les informations de base de votre devis.',
      title: 'Informations de base',
    },
    blocker: {
      message: 'Voulez-vous vraiment quitter cette page ? Les modifications apportées à votre devis n’ont pas été enregistrées.',
    },
    confirmation: {
      description:
        'Voulez-vous vraiment envoyer le devis ? Le devis n’est pas vérifié par nous, il est envoyé immédiatement à votre client.',
      submit: {
        create: 'Oui, envoyer le devis',
        edit: 'Oui, envoyer le devis',
      },
      title: 'Votre devis va être envoyé',
    },
    error: {
      title: 'Erreur lors du chargement de votre devis.',
    },
    lines: {
      description: 'Listez ici les produits et/ou services que vous proposez.',
      title: 'Lignes de devis',
    },
    preview: 'Exemple',
    submit: {
      create: 'Envoyer le devis',
      edit: 'Modifier le devis',
      saveConcept: 'Enregistrer',
      saveSend: 'Enregistrer et envoyer',
    },
    title: {
      create: 'Brouillon de devis',
      edit: 'Modifier le devis',
    },
  },
  fields: {
    attachment: {
      label: 'Pièce jointe',
    },
    description: {
      label: 'Description',
    },
    entryNumber: {
      label: 'Numéro de devis',
      last: 'Votre dernier devis porte le numéro <0>{{entryNumber}}</0>.',
      placeholder: 'Numéro de devis',
    },
    expirationDate: {
      label: 'Date d’échéance',
    },
    introduction: {
      label: 'Introduction',
    },
    mail: {
      default:
        '<p>\nBonjour #CLIENTNAME#,<br/><br/>\n\n#FREELANCERFIRSTNAME# a établi un devis pour vous. Pouvez-vous le consulter ?<br/><br/>\n\nLe voici : #QUOTATIONLINK#.<br/><br/>\n\nDès que vous l’aurez approuvé, #FREELANCERFIRSTNAME# pourra se mettre au travail.\n</p>',
      label: 'E-mail',
    },
  },
  header: {
    actionBlock: {
      button: 'Créer un devis',
    },
    title: 'Devis',
  },
  overview: {
    allowModal: {
      description: 'Voulez-vous vraiment marquer le devis comme approuvé ?',
      title: 'Marquer le devis comme approuvé',
    },
    columns: {
      client: 'Client',
      date: 'Date du devis',
      days: 'jours',
      entryNumber: 'Devis',
      status: {
        options: {
          Approved: 'Approuvé',
          Draft: 'Brouillon',
          Expired: 'Expiré',
          Rejected: 'Refusé',
          Sent: 'Envoyé',
        },
        title: 'Statut',
      },
      total: 'Total (hors TVA)',
    },
    declineModal: {
      description: 'Voulez-vous vraiment marquer le devis comme refusé ?',
      title: 'Marquer le devis comme refusé',
    },
    error: {
      title: 'Erreur lors du chargement de vos devis.',
    },
    rowActions: {
      allow: 'Approuver',
      decline: 'Refuser',
      download: 'Télécharger',
      duplicate: 'Copier',
      invoice: 'Créer une facture',
      preview: 'Consulter',
    },
  },
  quotationForClient: {
    error: {
      title: 'Erreur lors du chargement du devis.',
    },
  },
  richText: {
    shortcodes: {
      Clientname: 'Nom du client',
      Freelancerfirstname: 'Prénom du freelance',
      Quotationlink: 'Lien vers le devis',
    },
  },
};
